import script from "./AddValueTagsBasic.vue?vue&type=script&setup=true&lang=js"
export * from "./AddValueTagsBasic.vue?vue&type=script&setup=true&lang=js"

import "./AddValueTagsBasic.vue?vue&type=style&index=0&id=6570d248&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6570d248"]])

export default __exports__